'use es6';

import { MEETINGS_LINK_FETCH_SUCCEEDED } from '../../constants/ActionTypes';
const initialState = null;
export default ((state = initialState, action) => {
  switch (action.type) {
    case MEETINGS_LINK_FETCH_SUCCEEDED:
      return action.payload;

    default:
      return state;
  }
});